import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const dataPid = document.getElementById('root').getAttribute("data-startingpoint");
let host = window.location.hostname;

// console.log(host);
if (host === 'localhost') {
    host = 'https://www.hasit.de';
}

root.render(
  <React.StrictMode>
    <App dataPid={dataPid} host={host} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
